import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Power2, Power3, gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const HeaderContainer = styled.header`
  width: 100vw;
  height: 100vh;
`

const SiteTitle = styled.h1`
  font-size: 16vw;
  margin: 0px 0 0 0;
  text-align: center;
  padding-top: 20px;
  letter-spacing: -0.06em;
  line-height: 0.8;
  font-weight: 100;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  color:var(--black);
  
  font-weight:100;
  font-variation-settings: 'wght' 100;
  width:100%;

  .letter{
    padding-top:10px;
    /* padding-right:10px; */
    /* background: -webkit-linear-gradient(black, #262160 25%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
    display:inline-block;
    opacity:0.0;
    transform:translateY(100vh);
    /* transform:scale(0.5); */
  }
  .word{
    display:inline-block;

  }
  .word-01{
    display:inline-block;
    transform: translateX(-80vw);

  }

  .word-02{
    transform:translateY(-66vh);
    
  }

  .word-03{
    transform:translateX(-66vw);
  }
  .word-04{
    transform:translateX(75vw);
  }

  .word-05{
    transform:translateY(100vh);
  }
`

export default function SiteHeader () {
  let word = useRef(null)
  if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
    gsap.core.globals('ScrollTrigger', ScrollTrigger)
    gsap.config({ nullTargetWarn: false })
  }

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    gsap.to('.letter', {
      duration: 2,
      opacity: 1.0,
      scale: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut,
      stagger: {
        // grid: [6, 3],
        // from: 'center',
        amount: 0.5
      }
    })

    gsap.to('.word-01', {
      duration: 4,
      opacity: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut
    })

    gsap.to('.word-02', {
      duration: 3.9,
      opacity: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut
    })

    gsap.to('.word-03', {
      duration: 3.2,
      opacity: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut
    })
    gsap.to('.word-04', {
      duration: 3.6,
      opacity: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut
    })

    gsap.to('.word-05', {
      duration: 3.5,
      opacity: 1.0,
      x: 0,
      y: 0,
      ease: Power3.easeInOut
    })

    gsap.to(word, {
      scrollTrigger: {
        trigger: '.studentList',
        start: 'top center',
        end: '+=50%',

        scrub: true,
        toggleActions: 'restart pause reverse reverse'
      },
      y: '1vh',
      opacity: 0.0,
      scale: 0.9,
      duration: 1,
      ease: Power2.easeInOut

    })
  })
  return (
    <HeaderContainer>
      <SiteTitle ref={el => { word = el }}>
        <span className="word word-01">CCA</span> <span className="word word-02">MFA</span> <span className="word word-03">FINE</span> <span className="word word-04">ARTS</span> <span className="word word-05">2021</span>
      </SiteTitle>
    </HeaderContainer>
  )
}
